import React, { useState } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import { BaseButtons } from "../common-components";
import { AgencyInfoCard } from "./components";

const AgencyDescription = () => {
  const { width, height } = useWindowDimensions();

  return (
    <div
      style={{
        height: height,
        width: width,
        // backgroundColor: "#489FB5",
        backgroundColor: colors.primaryBlue,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        overflowY: "scroll",
      }}
    >
      {/* top menu diaply */}
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "flex-start",
          backgroundColor: colors.white,
          position: "fixed",
          height: 70,
          top: 0,
        }}
      >
        <img
          alt="logo"
          src={require("../../images/base-logo-desgns/driverfrinedlogo4.png")}
          style={{
            height: 70,
            marginLeft: 10,
            // position: "absolute",
            // left: 0,
            // bottom: -40,
            // padding: 10,
            backgroundColor: colors.white,
            borderRadius: 10,
            // WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          }}
        />
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"CONTACT US"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"DOCUMENTATION"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      <div style={{ minHeight: 70 }} />
      <AgencyInfoCard
        display={
          <div style={{ minHeight: 500, display: "flex", width: "100%" }}>
            <div
              style={{
                flex: 0.4,

                height: "100%",
                display: "flex",
                borderTopLeftRadius: 40,
                borderBottomLeftRadius: 40,
                overflow: "hidden",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>IMAGE</div>
            </div>
            <div
              style={{
                flex: 0.6,

                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  marginTop: 20,
                  marginBottom: 20,
                  fontSize: 22,
                  fontWeight: "bold",
                  color: colors.secondaryDarkBlue,
                }}
              >
                ABOUT AGENCY
              </div>
              <div style={{ width: "90%" }}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </div>
              <div style={{ width: "90%", marginTop: 10 }}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </div>
              <div style={{ flex: 1 }} />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <BaseButtons
                  label={"APPLY NOW"}
                  backgroundColor={colors.primaryBlue}
                  borderRadius={8}
                  width={"90%"}
                />
              </div>
            </div>
          </div>
        }
      />
      {/* <AgencyInfoCard display={<div style={{ minHeight: 100 }}></div>} /> */}
      <AgencyInfoCard
        display={
          <div style={{ minHeight: 500, display: "flex", width: "100%" }}>
            <div
              style={{
                flex: 0.4,

                height: "100%",
                display: "flex",
                borderTopLeftRadius: 40,
                borderBottomLeftRadius: 40,
                overflow: "hidden",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>IMAGE</div>
            </div>
            <div
              style={{
                flex: 0.6,

                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  marginTop: 20,
                  marginBottom: 20,
                  fontSize: 22,
                  fontWeight: "bold",
                  color: colors.secondaryDarkBlue,
                }}
              >
                DOCUMENTATION AND TUTORIALS
              </div>
              <div style={{ width: "90%" }}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </div>
              <div style={{ width: "90%", marginTop: 10 }}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </div>
              <div style={{ flex: 1 }} />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <BaseButtons
                  label={"COMING SOON"}
                  backgroundColor={colors.primaryBlue}
                  borderRadius={8}
                  width={"90%"}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        }
      />
      <div style={{ minHeight: 70 }} />
    </div>
  );
};

export default AgencyDescription;
